module.exports = __webpack_public_path__ + "img/gate_inprogress_badge.8de2357.svg";